import { MessageService } from 'primeng/api';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { provideRouter, withComponentInputBinding } from '@angular/router';
import { withInterceptors, provideHttpClient } from '@angular/common/http';
import { type ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';

import { routes } from './routes/app.routes';

import { environment } from '@environments/environment';
import { authInterceptor, baseUrlInterceptor, refreshInterceptor, unwrapApiEnvelopeInterceptor } from '@core/http';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        baseUrlInterceptor,
        refreshInterceptor,
        unwrapApiEnvelopeInterceptor,
        // delayInterceptor,
      ]),
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json',
      }),
      fallbackLang: environment.fallbackLocale,
      lang: environment.locale,
    }),
    MessageService,
  ],
};
